/**
 * React/ReactDOM globals bootstrap — MUST be imported before any module that
 * (statically or transitively) pulls the `@experience/shared-ui` barrel.
 *
 * The shared UI components (e.g. `Toast.tsx`, `StreamStatusPill.tsx`) read
 * `globalThis.React` at *module-init* time so they can share the host's React
 * when loaded as standalone plugin bundles. When those same components are
 * compiled into the shell via the source alias, ES-module import hoisting means
 * a static `import App from './App'` in `main.tsx` evaluates the barrel *before*
 * any assignment in the `main.tsx` body runs. Setting the globals here — in a
 * module imported first — guarantees `globalThis.React` is defined before the
 * barrel initializes, so `const { useState } = React` cannot throw.
 */
import React from 'react';
import * as ReactDOM from 'react-dom';

(window as any).React = React;
(globalThis as any).React = React;
(window as any).ReactDOM = ReactDOM;
(globalThis as any).ReactDOM = ReactDOM;

export {};
